import { apiFetch } from '~/utils/apiFetch'
import type {
  PlayerProfileDto,
  KycSubmitRequestDto,
  KycStatusDto,
  KycDetailsDto,
  KycPhotoUploadResponseDto,
} from '~/types/api/me'

/** GET /api/v1/me — 当前登录玩家档案 */
export function fetchMe() {
  return apiFetch<PlayerProfileDto>('/me')
}

/** GET /api/v1/kyc/status — 查询实名认证状态（none/pending/approved/rejected） */
export function fetchKycStatus() {
  return apiFetch<KycStatusDto>('/kyc/status')
}

/** GET /api/v1/kyc/details — 查询已提交的实名认证详情（姓名/证件号/到期日等） */
export function fetchKycDetails() {
  return apiFetch<KycDetailsDto>('/kyc/details')
}

/**
 * POST /api/v1/kyc/submissions — 提交实名认证资料（进入人工审核队列）
 * 身份证三张照片全填；护照两张且 photo_back_aid 必须缺席。
 * pending/approved 期间重复提交返回 409（业务码 3023），rejected 后可重交。
 */
export function submitKycSubmission(payload: KycSubmitRequestDto) {
  return apiFetch<null>('/kyc/submissions', {
    method: 'POST',
    body: payload,
  })
}

/**
 * POST /api/v1/kyc/photos — 上传 KYC 证件照片（multipart/form-data）。
 * 单张最大 5MB，支持 JPG/PNG/WebP；返回当前玩家专属 content_assets AID，
 * 填入提交接口的 photo_front_aid / photo_back_aid / photo_handheld_aid。
 *
 * 注意：FormData 交给 ofetch 时不要手动设置 Content-Type，由浏览器自动带 boundary。
 */
export async function uploadKycPhoto(file: File): Promise<string> {
  const form = new FormData()
  form.append('file', file)
  const res = await apiFetch<KycPhotoUploadResponseDto>('/kyc/photos', {
    method: 'POST',
    body: form,
  })
  return res.aid
}
